import React from 'react';
import { Plus, Download, Trash2 } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Tabs } from '../ui/Tabs';
interface AdminMarketingManagerProps {
  promoCodes: any[];
  banners: any[];
  setCreatePanel: (panel: any) => void;
  success: (msg: string) => void;
  handleDeletePromo: (id: number) => void;
  handleDeleteBanner: (id: number) => void;
  renderTableHeader: (title: string, count: number, onExport?: () => void, onCreate?: () => void, createLabel?: string) => React.ReactNode;
  generateCSV: (data: any[], name: string) => void;
}
export function AdminMarketingManager({
  promoCodes,
  banners,
  setCreatePanel,
  success,
  handleDeletePromo,
  handleDeleteBanner,
  renderTableHeader,
  generateCSV
}: AdminMarketingManagerProps) {
  return <div className="space-y-6" data-id="element-4759">
      <Tabs tabs={[{
      id: 'promos',
      label: 'Промокоды',
      content: <div className="space-y-4" data-id="element-4761">
                {renderTableHeader('Промокоды', promoCodes.length, () => generateCSV(promoCodes, 'promos'), () => setCreatePanel({
          type: 'promo',
          title: 'Создать промокод'
        }), 'Создать')}
                <Card padding="none" className="rounded-xl shadow-none border-slate-200 overflow-hidden" data-id="element-4762">
                  <table className="w-full text-left" data-id="element-4763">
                    <thead className="bg-slate-50 text-slate-500 border-b border-slate-200 text-[11px] uppercase tracking-wider" data-id="element-4764">
                      <tr data-id="element-4765">
                        <th className="px-3 py-2" data-id="element-4766">Код</th>
                        <th className="px-3 py-2" data-id="element-4767">Скидка</th>
                        <th className="px-3 py-2" data-id="element-4768">Использовано</th>
                        <th className="px-3 py-2" data-id="element-4769">Истекает</th>
                        <th className="px-3 py-2" data-id="element-4770">Статус</th>
                        <th className="px-3 py-2" data-id="element-4771"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100" data-id="element-4772">
                      {promoCodes.map(p => <tr key={p.id} className="hover:bg-slate-50" data-id="element-4773">
                          <td className="px-3 py-2 font-mono text-sm font-bold text-slate-900" data-id="element-4774">
                            {p.code}
                          </td>
                          <td className="px-3 py-2 text-sm text-emerald-600 font-medium" data-id="element-4775">
                            {p.discount}
                          </td>
                          <td className="px-3 py-2 text-sm" data-id="element-4776">
                            {p.used} / {p.limit}
                          </td>
                          <td className="px-3 py-2 text-sm text-slate-500" data-id="element-4777">
                            {p.expires}
                          </td>
                          <td className="px-3 py-2" data-id="element-4778">
                            <Badge variant={p.status === 'active' ? 'success' : 'neutral'} size="sm" data-id="element-4779">
                              {p.status === 'active' ? 'Активен' : 'Истёк'}
                            </Badge>
                          </td>
                          <td className="px-3 py-2 text-right" data-id="element-4780">
                            <Button variant="ghost" size="sm" className="text-rose-500" icon={<Trash2 className="w-3 h-3" data-id="element-4782" />} onClick={() => handleDeletePromo(p.id)} data-id="element-4781" />
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </Card>
              </div>
    }, {
      id: 'banners',
      label: 'Баннеры',
      content: <div className="space-y-4" data-id="element-4783">
                {renderTableHeader('Баннеры', banners.length, () => generateCSV(banners, 'banners'), () => setCreatePanel({
          type: 'ad',
          title: 'Добавить баннер'
        }), 'Добавить')}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4784">
                  {banners.map(b => <Card key={b.id} padding="md" data-id="element-4785">
                      <div className="flex justify-between items-start mb-3" data-id="element-4786">
                        <div data-id="element-4787">
                          <h3 className="font-bold text-slate-900" data-id="element-4788">
                            {b.title}
                          </h3>
                          <p className="text-xs text-slate-500" data-id="element-4789">
                            Размещение: {b.placement}
                          </p>
                        </div>
                        <Badge variant={b.status === 'active' ? 'success' : 'neutral'} size="sm" data-id="element-4790">
                          {b.status === 'active' ? 'Активен' : 'Остановлен'}
                        </Badge>
                      </div>
                      <div className="h-24 bg-slate-100 rounded-lg border-2 border-dashed border-slate-200 flex items-center justify-center text-slate-400 text-xs mb-3" data-id="element-4791">
                        Превью баннера
                      </div>
                      <div className="flex justify-between items-center" data-id="element-4792">
                        <Button variant="outline" size="sm" onClick={() => success(b.status === 'active' ? 'Баннер остановлен' : 'Баннер запущен')} data-id="element-4793">
                          {b.status === 'active' ? 'Остановить' : 'Запустить'}
                        </Button>
                        <Button variant="ghost" size="sm" className="text-rose-500" icon={<Trash2 className="w-4 h-4" data-id="element-4795" />} onClick={() => handleDeleteBanner(b.id)} data-id="element-4794" />
                      </div>
                      <div className="flex gap-4 mt-3 text-xs text-slate-600" data-id="element-4796">
                        <span data-id="element-4797">👁 {b.views.toLocaleString()}</span>
                        <span data-id="element-4798">👆 {b.clicks.toLocaleString()}</span>
                        <span data-id="element-4799">
                          CTR: {(b.clicks / b.views * 100).toFixed(1)}%
                        </span>
                      </div>
                    </Card>)}
                </div>
              </div>
    }]} data-id="element-4760" />
    </div>;
}